import { render, staticRenderFns } from "./SearchDegreeDetail.vue?vue&type=template&id=5f3615db&scoped=true&"
import script from "./SearchDegreeDetail.vue?vue&type=script&lang=js&"
export * from "./SearchDegreeDetail.vue?vue&type=script&lang=js&"
import style0 from "./SearchDegreeDetail.vue?vue&type=style&index=0&id=5f3615db&scoped=true&lang=scss&"
import style1 from "./SearchDegreeDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3615db",
  null
  
)

export default component.exports